import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import TextareaAutosize from 'react-textarea-autosize';
import { FormattedMessage } from 'react-intl';


class Field extends React.Component {

    constructor(props, context) {

        super(props, context);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleModalCloseRequest = this.handleModalCloseRequest.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onCurrencyChange = this.onCurrencyChange.bind(this);

        this.state = {
            modalIsOpen: false,
            modalFormValue: null,
            modalFormCurrency: null,
            minLength: null,
            maxLength: null,
            regex: null,
            counter: null,
            hasError: false,
            hasErrorCurrency: false,
            errorMessage: null
        }
    }

    static get defaultProps() {
        return {
            formKey: null,
            formType: 'text',
            formValue: null,
            editable: false,
            area: null
        }
    }

    openModal(value) {

        const { area, ConfiguratorManager, formKey, formType } = this.props;

        const areaId = area.id;

        // get length of value
        let textLength = 0;
        if (value && value.length > 0) {
            textLength = value.length;
        }

        // split value by whitespace
        let currencyValue = null;
        if (formType === 'price') {
            if (value) {
                const splittedValue = value.split(" ");
                if (splittedValue && splittedValue.length === 2) {
                    value = splittedValue[0];
                    currencyValue = splittedValue[1];
                } else {
                    currencyValue = '€';
                }
            } else {
                currencyValue = '€';
            }
        }

        // default values
        let minLength = null;
        let maxLength = null;
        let regex = null;
        let errorMessage = 'The form value is not valid!';
        let counter = null;

        // get constraints
        const constraints = ConfiguratorManager.getInputConstraints(areaId, formKey);
        if (constraints && constraints.minLength) {
            minLength = constraints.minLength;
        }
        if (constraints && constraints.maxLength) {
            maxLength = constraints.maxLength;
        }
        if (constraints && constraints.regex) {
            regex = constraints.regex;
        }
        if (constraints && constraints.errorMessage) {
            errorMessage = constraints.errorMessage;
        }
        if (maxLength !== null) {
            counter = maxLength - textLength;
        }

        let oldState = this.state;
        let newState = {
            ...oldState,
            modalIsOpen: true,
            modalFormValue: value,
            modalFormCurrency: currencyValue,
            minLength: minLength,
            maxLength: maxLength,
            regex: regex,
            errorMessage: errorMessage,
            counter: counter,
            hasError: false,
        };

        this.setState(newState);
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    handleModalCloseRequest() {
        this.setState({modalIsOpen: false});
    }

    handleSave(event) {

        const {index, formKey, editField, formType} = this.props;

        event.preventDefault();
        const value = this.state.modalFormValue;

        let valueLength = 0;
        if (value && value.length) {
            valueLength = value.length;
        }

        // some checks
        let hasError = false;
        let hasErrorCurrency = false;
        if (this.state.minLength &&  valueLength < this.state.minLength) {
            console.error('[PLSK] - FormField Error, minlength');
            hasError = true;
        }
        if (this.state.maxLength &&  valueLength > this.state.maxLength) {
            console.error('[PLSK] - FormField Error, maxlength');
            hasError = true;
        }
        if (this.state.regex && value && value.length > 0) {
            const rx = new RegExp(this.state.regex);
            if (!rx.test(value)) {
                console.error('[PLSK] - FormField Error, regex');
                hasError = true;
            }
        }


        if (!hasError && formType === 'price' && value) {
            if (!this.state.modalFormCurrency) {
                console.error('[PLSK] - Currency on price fieldType required if a value is set');
                hasErrorCurrency = true;
            }
        }

        this.setState({hasError: hasError, hasErrorCurrency: hasErrorCurrency});

        if (hasError === false && hasErrorCurrency === false) {

            this.closeModal();

            // on fieldType "price" we add the currency to value
            // only if a value is set
            let dataValue = value;
            if (dataValue && (formType === 'price')) {
                dataValue = dataValue + ' ' + this.state.modalFormCurrency;
            }

            let formData = {
                value: dataValue,
            };

            // function defined in AreaComponent
            editField(index, formKey, formData.value);

            this.state.modalFormCurrency = null;
            this.state.modalFormValue = dataValue;

        }
    }

    onTextChange(event) {

        const textValue = event.target.value;
        let textLength = 0;
        if (textValue && textValue.length > 0) {
            textLength = textValue.length;
        }

        let newCount = null;
        if (this.state.maxLength !== null && this.state.maxLength > 0) { // count only if maxLength defined
            newCount = this.state.maxLength - textLength;
        }
        this.setState({ modalFormValue: textValue, counter: newCount })
    }

    onCurrencyChange(event) {
        const currencyValue = event.target.value;
        this.setState({ modalFormCurrency: currencyValue })
    }

    handleCheckbox(event) {
        const { index, formKey, formValue, editField} = this.props;
        const newValue = !formValue; // revert value
        editField(index, formKey, newValue);
    }

    render() {
        let { formKey, formValue, formType, editable, area  } = this.props;

        let className = 'configurator-field';
        if (editable) {
            className = className + ' editable';
        }

        let checkBoxId = null;
        if(area) {
            checkBoxId = area.id + "--checkbox";
        }

        let FieldElement = <span className={className}>{formValue}</span>;

        if (editable && formType === 'text') {

            // TODO ... get placeholder from config
            const InputField =   <TextareaAutosize
                className="form-control"
                maxLength={this.state.maxLength}
                placeholder="Wert eingeben ..."
                defaultValue={this.state.modalFormValue}
                onChange={this.onTextChange}
                ref="fieldValue"
                maxRows={6}
            ></TextareaAutosize>;

            let Error = null;
            let FormGroupCss = 'form-group';
            if (this.state.hasError === true) {
                Error = <small className="help-block">{this.state.errorMessage}</small>;
                FormGroupCss += ' has-error';
            }

            let Counter = null;
            if (this.state.counter !== null) {
                Counter = <div className="input-counter"><FormattedMessage id="TEXT_CHARACTER_COUNT_CHARACTERS_LEFT" /> {this.state.counter}</div>;
            }

            let MinLength = null;
            if (this.state.minLength != null) {
                MinLength = <div className="input-counter"><FormattedMessage id="TEXT_CHARACTER_COUNT_MIN_LENGTH" /> {this.state.minLength}</div>
            }


            FieldElement = <span>
                <span className={className} onClick={() => this.openModal(formValue)}>{formValue}</span>
                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.handleModalCloseRequest}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.handleModalCloseRequest}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Close</span>
                            </button>
                            <h4 className="modal-title"><FormattedMessage id="LABEL_EDIT_FIELD"/></h4>
                        </div>

                        <div className="modal-body">
                            <form className="form-horizontal" role="form" onSubmit={event => this.handleSave(event)}>
                                <div className={FormGroupCss}>
                                    <label className="control-label col-sm-2" htmlFor="fieldValue"><FormattedMessage id="LABEL_VALUE"/></label>
                                    <div className="col-sm-10">
                                        {InputField}
                                        {Error}
                                        {Counter}
                                        {MinLength}
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" onClick={this.handleModalCloseRequest}>
                                <FormattedMessage id="LABEL_CANCEL"/>
                            </button>
                            <button type="button" className="btn btn-primary" onClick={event => this.handleSave(event)}><FormattedMessage id="LABEL_SAVE"/></button>
                        </div>
                    </div>
                </Modal>
            </span>;

        }  else if (editable && formType === 'price') {

            const InputField =   <input
                className="form-control"
                placeholder="Preis eingeben ..."
                defaultValue={this.state.modalFormValue}
                ref="fieldValue"
                onChange={this.onTextChange}
            ></input>;
            let Error = null;
            let FormGroupCss = 'form-group';
            let FormValueCss = 'col-sm-8';
            let FormCurrencyCss = 'col-sm-2';
            if (this.state.hasError === true) {
                Error = <small className="help-block">{this.state.errorMessage}</small>;
                FormValueCss += ' has-error';
            }
            if (this.state.hasErrorCurrency === true) {
                Error = <small className="help-block">{this.state.errorMessage}</small>;
                FormCurrencyCss += ' has-error';
            }

            FieldElement = <span>
                <span className={className} onClick={() => this.openModal(formValue)}>{formValue}</span>
                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.handleModalCloseRequest}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.handleModalCloseRequest}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Close</span>
                            </button>
                            <h4 className="modal-title"><FormattedMessage id="LABEL_EDIT_FIELD"/></h4>
                        </div>

                        <div className="modal-body">
                            <form className="form-horizontal" role="form" onSubmit={event => this.handleSave(event)}>
                                <div className={FormGroupCss}>
                                    <label className="control-label col-sm-2" htmlFor="fieldValue"><FormattedMessage id="LABEL_VALUE"/></label>
                                    <div className={FormValueCss}>
                                      {InputField}
                                    </div>
                                    <div className={FormCurrencyCss}>
                                        <input defaultValue={this.state.modalFormCurrency}
                                               onChange={this.onCurrencyChange}
                                               className="form-control"></input>
                                    </div>
                                    <label className="control-label col-sm-2"></label>
                                    <div className="col-sm-10">{Error}</div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" onClick={this.handleModalCloseRequest}>
                                <FormattedMessage id="LABEL_CANCEL"/>
                            </button>
                            <button type="button" className="btn btn-primary" onClick={event => this.handleSave(event)}><FormattedMessage id="LABEL_SAVE"/></button>
                        </div>
                    </div>
                </Modal>
            </span>;

        } else if (formType === 'checkbox') {
            FieldElement = <input id={checkBoxId} class="test" type="checkbox" checked={formValue} ref="fieldValue" onClick={event => this.handleCheckbox(event)} />;
        }

        return (
            <span>
            { FieldElement }
            </span>
        )
    }
}

export default Field;



// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/Field.react.jsx